import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrameSizeSelectorComponent } from '@nrwl/test-setup';
import { MatDialog } from '@angular/material/dialog';
import { CommonMaterialModule } from '@nrwl/common-material';
import { state, style, transition, trigger, animate } from '@angular/animations';
import { FormsModule } from '@angular/forms';
import {
  BaseSetupTab,
  IComponentStateHistory,
  IValueChangedEvent,
  REMOVED
} from '@nrwl/test-setup';
import {
  A2B_TABLE_COLUMNS,
  B2A_TABLE_COLUMNS,
  UDPConfigFieldMapping as ConfigFieldMapping,
  STREAM_NUMBERS_A2B,
  STREAM_NUMBERS_B2A,
  UDP_PORT_LIST
} from '../../models/models';
import { FormatService } from '@nrwl/common-lib';
import { Subject, Subscription } from 'rxjs';
import { UdpSetupService } from '../../udp-setup.service';
import { isNil, cloneDeep, isEmpty } from 'lodash';
import { MatTableDataSource } from '@angular/material/table';
import { UdpStreamTypeComponent } from '../udp-stream-type/udp-stream-type.component';
@Component({
  selector: 'nrwl-udp-streams',
  standalone: true,
  imports: [CommonModule, FrameSizeSelectorComponent, CommonMaterialModule, FormsModule],
  templateUrl: './udp-streams.component.html',
  styleUrls: ['./udp-streams.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('isExpanded', style({ height: '*', visibility: 'visible' })),
      transition('isExpanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class UdpStreamsComponent implements OnInit, OnDestroy {
  @Input() tab: BaseSetupTab;
  @Input() componentId: string;
  @Input() stateHistory: IComponentStateHistory;
  // eslint-disable-next-line
  @Input() restoreAgentBasedConfig?: Function;
  // eslint-disable-next-line
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  isValidRemoveActionA2B = false;
  isValidCloneActionA2B = false;
  isValidRemoveActionB2A = false;
  isValidCloneActionB2A = false;
  config: any;
  parentConfig: any;
  outputs: Array<string>;
  configMapping = ConfigFieldMapping;
  tabsubscription: Subscription;
  agentSubscription: Subscription;
  readonly unsubscribe: Subject<void> = new Subject();
  defaultStreamsArrA2B: any;
  defaultStreamsArrB2A: any;
  udpPortList = UDP_PORT_LIST;
  streamNumbersA2B = STREAM_NUMBERS_A2B;
  streamNumbersB2A = STREAM_NUMBERS_B2A;
  usedStreamNumbersA2B = [];
  usedStreamNumbersB2A = [];
  availableStreamNumbersA2B = [];
  availableStreamNumbersB2A = [];
  usedPortsA2B = [];
  usedPortsB2A = [];
  availablePortsA2B = [];
  availablePortsB2A = [];
  allStreamsConfigA2B: Array<any>;
  allStreamsConfigB2A: Array<any>;
  dataSourceA2B = new MatTableDataSource();
  dataSourceB2A = new MatTableDataSource();
  direction = '';
  streamRateConvention = '';
  vlan = 46;
  validateAllStreamsA2B;
  validateAllStreamsB2A;
  frameSizesObj = {};
  maxBandWidth = 10000;
  initiateDefaultStreamA2B = {};
  initiateDefaultStreamB2A = {};
  streamRowsA2B = [
    {
      isMultiSelectEnable: false,
      framesList: [],
      streamMaxServices: 10,
      streamNumber: 1,
      streamName: 'service 1',
      streamType: 'Data',
      streamL2IrA2B: '10.00',
      streamUdpBwA2B: '9.10',
      streamL2IrB2A: '10.00',
      streamUdpBwB2A: '9.10',
      streamFrameSize: 512,
      streamPacketLossRatio: '0',
      streamJitterThreshold: '0',
      streamUdpPort: 8080,
      streamCodec: null,
      streamSamplingRate: null,
      streamCalls: null,
      streamVideoType: null,
      streamCompression: null,
      streamChannels: null,
      isValidConfig: true,
      strmInUse: true,
      streamAction: ''
    }
  ];
  streamRowsB2A = [
    {
      isMultiSelectEnable: false,
      framesList: [],
      streamMaxServices: 10,
      streamNumber: 11,
      streamName: 'service 11',
      streamType: 'Data',
      streamL2IrB2A: '10.00',
      streamUdpBwB2A: '9.10',
      streamFrameSize: 512,
      streamPacketLossRatio: '0',
      streamJitterThreshold: '0',
      streamUdpPort: 8080,
      streamCodec: null,
      streamSamplingRate: null,
      streamCalls: null,
      streamVideoType: null,
      streamCompression: null,
      streamChannels: null,
      isValidConfig: true,
      strmInUse: true,
      streamAction: ''
    }
  ];
  errorValidationObj = {
    isValidName: true,
    isValidDisableStream: true
  };
  a2bTableColumns = A2B_TABLE_COLUMNS;
  b2aTableColumns = B2A_TABLE_COLUMNS;
  totalIrA2B: any = 0;
  totalBwA2B: any = 0;
  totalIrB2A: any = 0;
  totalBwB2A: any = 0;
  isValidRemove = false;

  constructor(
    public setupService: UdpSetupService,
    public formatService: FormatService,
    private dialog: MatDialog
  ) {
    this.dataSourceA2B.data = this.streamRowsA2B;
    this.dataSourceB2A.data = this.streamRowsB2A;
    this.initiateDefaultStreamA2B = this.streamRowsA2B[0];
    this.initiateDefaultStreamB2A = this.streamRowsB2A[0];
    this.usedPortsA2B.push(this.streamRowsA2B[0].streamUdpPort);
    this.usedPortsB2A.push(this.streamRowsB2A[0].streamUdpPort);
    this.availableStreamNumbersA2B = this.streamNumbersA2B.filter(
      item => !this.usedStreamNumbersA2B.includes(item)
    );
    this.availableStreamNumbersB2A = this.streamNumbersB2A.filter(
      item => !this.usedStreamNumbersB2A.includes(item)
    );
    this.availablePortsA2B = this.udpPortList.filter(item => !this.usedPortsA2B.includes(item));
    this.availablePortsB2A = this.udpPortList.filter(item => !this.usedPortsB2A.includes(item));
  }

  ngOnInit(): void {
    this.restoreFormValues();
    if (this.direction !== 'unidirectional-b2a') {
      this.validateStream('tableA');
    }
    if (this.direction !== 'unidirectional-a2b') {
      this.validateStream('tableB');
    }
    if (this.setupService.tabDataChangeEvents) {
      this.tabsubscription = this.setupService.tabDataChangeEvents.subscribe(event => {
        if (event === 1) {
          this.restoreFormValues();
          if (this.direction !== 'unidirectional-b2a') {
            this.validateStream('tableA');
          }
          if (this.direction !== 'unidirectional-a2b') {
            this.validateStream('tableB');
          }
          this.onDataChange();
        }
      });
    }
  }
  restoreFormValues(): void {
    this.config = this.tab?.config;
    this.restoreOtherTabValues();
    if (this.setupService?.getOriginatorAgent() && this.config) {
      const selectedDevice = this.setupService?.getOriginatorAgent();
      this.maxBandWidth = selectedDevice.deviceData.capabilities?.['phy-list']
        ? selectedDevice.deviceData.capabilities?.['udp-list'].find(
            item => item['phy-id'] === selectedDevice.deviceData?.phyId
          )['max-bandwidth']
        : selectedDevice.deviceData?.capabilities?.udp?.['max-bandwidth'];
    }
    this.defaultStreamsArrA2B = cloneDeep(this.restoreFieldValues(ConfigFieldMapping.STREAMS_A2B));
    this.defaultStreamsArrB2A = cloneDeep(this.restoreFieldValues(ConfigFieldMapping.STREAMS_B2A));
    this.parentConfig = this.tab?.['parent']['output'];
    this.outputs = this.config?.def?.outputs;
    const defaultStreamRowA2B = this.streamRowsA2B[0];
    const defaultStreamRowB2A = this.streamRowsB2A[0];
    this.streamRowsA2B = [];
    this.streamRowsB2A = [];
    this.allStreamsConfigA2B = cloneDeep(this.restoreFieldValues(ConfigFieldMapping.STREAMS_A2B));
    this.allStreamsConfigB2A = cloneDeep(this.restoreFieldValues(ConfigFieldMapping.STREAMS_B2A));
    if (this.direction === 'unidirectional-b2a' && this.allStreamsConfigB2A[0]['name'] === null) {
      this.allStreamsConfigB2A[0]['name'] = 'service 1';
    } else if (
      this.direction !== 'unidirectional-a2b' &&
      this.allStreamsConfigB2A[0]['name'] === null
    ) {
      this.allStreamsConfigB2A[0]['name'] = 'service 11';
    }
    const maxServicesA2B = this.restoreFieldValues(ConfigFieldMapping.MAX_SERVICES);
    const maxServicesB2A = this.restoreFieldValues(ConfigFieldMapping.MAX_SERVICES);
    if (this.allStreamsConfigA2B?.length > maxServicesA2B) {
      this.allStreamsConfigA2B.length = maxServicesA2B;
    }
    if (this.allStreamsConfigB2A?.length > maxServicesB2A) {
      this.allStreamsConfigB2A.length = maxServicesB2A;
    }
    for (let i = 0; i < this.allStreamsConfigA2B?.length; i++) {
      this.streamRowsA2B.push(cloneDeep(defaultStreamRowA2B));
    }
    for (let i = 0; i < this.allStreamsConfigB2A?.length; i++) {
      this.streamRowsB2A.push(cloneDeep(defaultStreamRowB2A));
    }
    for (let i = 0; i < this.allStreamsConfigA2B?.length; i++) {
      this.allStreamsConfigA2B[i] = this.updateStreamData(
        this.allStreamsConfigA2B[i],
        this.vlan,
        this.streamRateConvention,
        'tableA'
      );
      this.streamRowsA2B[i].streamNumber =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.STREAM_NUMBER];
      this.streamRowsA2B[i].streamName =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.STREAM_NAME];
      this.streamRowsA2B[i].streamType =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.STREAM_TYPE];
      this.streamRowsA2B[i].streamL2IrA2B =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.STREAM_L2_IR_A2B];
      this.streamRowsA2B[i].streamUdpBwA2B =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.UDP_BW_A2B];
      this.streamRowsA2B[i].streamFrameSize =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.FRAME_SIZE];
      this.streamRowsA2B[i].streamPacketLossRatio =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.POCKET_LOSS_RATIO];
      this.streamRowsA2B[i].streamJitterThreshold =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.JITTER_THRESHOLD];
      this.streamRowsA2B[i].streamUdpPort =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.UDP_PORT];
      this.streamRowsA2B[i].streamMaxServices = this.restoreFieldValues(
        ConfigFieldMapping.MAX_SERVICES
      );
      this.streamRowsA2B[i].strmInUse =
        this.allStreamsConfigA2B[i][ConfigFieldMapping.STREAM_IN_USE] ?? true;
      if (this.streamRowsA2B[i].streamType === 'Video') {
        this.streamRowsA2B[i].streamVideoType =
          this.allStreamsConfigA2B[i][ConfigFieldMapping.VIDEO_TYPE];
        this.streamRowsA2B[i].streamCompression =
          this.allStreamsConfigA2B[i][ConfigFieldMapping.COMPRESSION];
        this.streamRowsA2B[i].streamChannels =
          this.allStreamsConfigA2B[i][ConfigFieldMapping.CHANNELS];
      }
      if (this.streamRowsA2B[i].streamType === 'Voice') {
        this.streamRowsA2B[i].streamCodec = this.allStreamsConfigA2B[i][ConfigFieldMapping.CODEC];
        this.streamRowsA2B[i].streamSamplingRate =
          this.allStreamsConfigA2B[i][ConfigFieldMapping.SAMPLING_RATE];
        this.streamRowsA2B[i].streamCalls = this.allStreamsConfigA2B[i][ConfigFieldMapping.CALLS];
      }
      if (
        !this.usedStreamNumbersA2B.includes(
          this.allStreamsConfigA2B[i][ConfigFieldMapping.STREAM_NUMBER]
        )
      ) {
        this.usedStreamNumbersA2B.push(
          this.allStreamsConfigA2B[i][ConfigFieldMapping.STREAM_NUMBER]
        );
      }
      if (
        !this.usedPortsA2B.includes(
          Number(this.allStreamsConfigA2B[i][ConfigFieldMapping.UDP_PORT])
        )
      ) {
        this.usedPortsA2B.push(Number(this.allStreamsConfigA2B[i][ConfigFieldMapping.UDP_PORT]));
      }
    }
    for (let i = 0; i < this.allStreamsConfigB2A?.length; i++) {
      this.allStreamsConfigB2A[i] = this.updateStreamData(
        this.allStreamsConfigB2A[i],
        this.vlan,
        this.streamRateConvention,
        'tableB'
      );
      this.streamRowsB2A[i].streamNumber =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.STREAM_NUMBER];
      this.streamRowsB2A[i].streamName =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.STREAM_NAME];
      this.streamRowsB2A[i].streamType =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.STREAM_TYPE];
      this.streamRowsB2A[i].streamL2IrB2A =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.STREAM_L2_IR_B2A];
      this.streamRowsB2A[i].streamUdpBwB2A =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.UDP_BW_B2A];
      this.streamRowsB2A[i].streamFrameSize =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.FRAME_SIZE];
      this.streamRowsB2A[i].streamPacketLossRatio =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.POCKET_LOSS_RATIO];
      this.streamRowsB2A[i].streamJitterThreshold =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.JITTER_THRESHOLD];
      this.streamRowsB2A[i].streamUdpPort =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.UDP_PORT];
      this.streamRowsB2A[i].streamMaxServices = this.restoreFieldValues(
        ConfigFieldMapping.MAX_SERVICES
      );
      this.streamRowsB2A[i].strmInUse =
        this.allStreamsConfigB2A[i][ConfigFieldMapping.STREAM_IN_USE] ?? true;
      if (this.streamRowsB2A[i].streamType === 'Video') {
        this.streamRowsB2A[i].streamVideoType =
          this.allStreamsConfigB2A[i][ConfigFieldMapping.VIDEO_TYPE];
        this.streamRowsB2A[i].streamCompression =
          this.allStreamsConfigB2A[i][ConfigFieldMapping.COMPRESSION];
        this.streamRowsB2A[i].streamChannels =
          this.allStreamsConfigB2A[i][ConfigFieldMapping.CHANNELS];
      }
      if (this.streamRowsB2A[i].streamType === 'Voice') {
        this.streamRowsB2A[i].streamCodec = this.allStreamsConfigB2A[i][ConfigFieldMapping.CODEC];
        this.streamRowsB2A[i].streamSamplingRate =
          this.allStreamsConfigB2A[i][ConfigFieldMapping.SAMPLING_RATE];
        this.streamRowsB2A[i].streamCalls = this.allStreamsConfigB2A[i][ConfigFieldMapping.CALLS];
      }
      if (
        !this.usedStreamNumbersB2A.includes(
          this.allStreamsConfigB2A[i][ConfigFieldMapping.STREAM_NUMBER]
        )
      ) {
        this.usedStreamNumbersB2A.push(
          this.allStreamsConfigB2A[i][ConfigFieldMapping.STREAM_NUMBER]
        );
      }
      if (
        !this.usedPortsB2A.includes(
          Number(this.allStreamsConfigB2A[i][ConfigFieldMapping.UDP_PORT])
        )
      ) {
        this.usedPortsB2A.push(Number(this.allStreamsConfigB2A[i][ConfigFieldMapping.UDP_PORT]));
      }
    }
    this.availablePortsA2B = this.udpPortList.filter(port => !this.usedPortsA2B.includes(port));
    this.availablePortsB2A = this.udpPortList.filter(port => !this.usedPortsB2A.includes(port));
    this.frameSizesObj = this.restoreFieldValues(ConfigFieldMapping.VALID_FRAME_SIZES);
    this.dataSourceA2B.data = this.streamRowsA2B;
    this.dataSourceB2A.data = this.streamRowsB2A;
  }

  restoreOtherTabValues(): void {
    this.direction = this.restoreFieldValues(ConfigFieldMapping.DIRECTION);
    this.streamRateConvention = this.restoreFieldValues(ConfigFieldMapping.STREAM_RATE_CONVENTION);
    this.vlan = this.restoreFieldValues(ConfigFieldMapping.VLAN);
  }

  restoreFieldValues(field: string): any {
    const data = this.stateHistory(this.componentId, field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }
  // eslint-disable-next-line
  cloneStream(rowData: any, tableChange: string): void {
    if (tableChange === 'tableA') {
      if (this.streamRowsA2B.length < 10) {
        this.createDataSource(rowData, tableChange);
      }
      this.validateStream(tableChange);
      this.onDataChange();
    } else {
      if (this.streamRowsB2A.length < 10) {
        this.createDataSource(rowData, tableChange);
      }
      this.validateStream(tableChange);
      this.onDataChange();
    }
  }
  // eslint-disable-next-line
  removeStream(rowData: any, tableChange: string): void {
    if (tableChange === 'tableA') {
      if (this.streamRowsA2B.length > 1) {
        this.streamRowsA2B = this.streamRowsA2B.filter(
          item => item['streamNumber'] !== rowData.streamNumber
        );
        this.dataSourceA2B.data = this.streamRowsA2B;
        this.allStreamsConfigA2B = this.allStreamsConfigA2B.filter(
          item => item[ConfigFieldMapping.STREAM_NUMBER] !== rowData.streamNumber
        );
      }
      this.usedPortsA2B = this.usedPortsA2B.filter(item => item !== rowData.streamUdpPort);
      this.availablePortsA2B = this.udpPortList.filter(port => !this.usedPortsA2B.includes(port));
      this.usedStreamNumbersA2B = this.usedStreamNumbersA2B.filter(
        item => item !== rowData.streamNumber
      );
      this.validateStream(tableChange);
      this.onDataChange();
    } else {
      if (this.streamRowsB2A.length > 1) {
        this.streamRowsB2A = this.streamRowsB2A.filter(
          item => item['streamNumber'] !== rowData.streamNumber
        );
        this.dataSourceB2A.data = this.streamRowsB2A;
        this.allStreamsConfigB2A = this.allStreamsConfigB2A.filter(
          item => item[ConfigFieldMapping.STREAM_NUMBER] !== rowData.streamNumber
        );
      }
      this.usedPortsB2A = this.usedPortsB2A.filter(item => item !== rowData.streamUdpPort);
      this.availablePortsB2A = this.udpPortList.filter(port => !this.usedPortsB2A.includes(port));
      this.usedStreamNumbersB2A = this.usedStreamNumbersB2A.filter(
        item => item !== rowData.streamNumber
      );
      this.validateStream(tableChange);
      this.onDataChange();
    }
  }

  validateStream(tableChange: string): void {
    if (tableChange === 'tableA') {
      if (this.streamRowsA2B.length < this.streamRowsA2B[0].streamMaxServices) {
        this.isValidCloneActionA2B = false;
        if (this.streamRowsA2B.length > 1) {
          this.isValidRemoveActionA2B = false;
        } else {
          this.isValidRemoveActionA2B = true;
        }
      } else {
        this.isValidRemoveActionA2B = false;
        this.isValidCloneActionA2B = true;
        if (this.direction === 'unidirectional-a2b') {
          this.isValidCloneActionB2A = true;
        }
      }
    } else {
      if (this.streamRowsB2A.length < this.streamRowsB2A[0].streamMaxServices) {
        this.isValidCloneActionB2A = false;
        if (this.streamRowsB2A.length > 1) {
          this.isValidRemoveActionB2A = false;
        } else {
          this.isValidRemoveActionB2A = true;
        }
      } else {
        this.isValidRemoveActionB2A = false;
        this.isValidCloneActionB2A = true;
      }
      if (this.direction === 'unidirectional-b2a') {
        this.isValidCloneActionA2B = true;
      }
    }
  }
  // eslint-disable-next-line
  onDataChange(value?: any, index?: number, name?: string, tableChange?: string): void {
    // Table A2B data changes
    this.validateAllStreamsA2B = this.streamRowsA2B.map(item => item['isValidConfig']);
    if (name && tableChange === 'tableA') {
      this.allStreamsConfigA2B[index][name] = value;
    }
    if (
      this.streamRowsA2B[0].streamMaxServices <= this.streamRowsA2B.length - 1 ||
      this.validateAllStreamsA2B?.includes(false)
    ) {
      this.onDataEmit(ConfigFieldMapping.STREAMS_A2B, this.allStreamsConfigA2B, false);
    } else {
      this.onDataEmit(ConfigFieldMapping.STREAMS_A2B, this.allStreamsConfigA2B, true);
    }
    this.usedPortsA2B = [];
    this.usedStreamNumbersA2B = [];
    this.allStreamsConfigA2B.forEach(stream => {
      if (stream) {
        this.usedPortsA2B.push(Number(stream['udp-port']));
        this.usedStreamNumbersA2B.push(stream['stream-number']);
      }
    });
    this.availablePortsA2B = this.udpPortList.filter(port => !this.usedPortsA2B.includes(port));
    this.availableStreamNumbersA2B = this.streamNumbersA2B.filter(
      item => !this.usedStreamNumbersA2B.includes(item)
    );

    // Table B2A data changes
    this.validateAllStreamsB2A = this.streamRowsB2A.map(item => item['isValidConfig']);
    if (name && tableChange === 'tableB') {
      this.allStreamsConfigB2A[index][name] = value;
    }
    if (
      this.streamRowsB2A[0].streamMaxServices <= this.streamRowsB2A.length - 1 ||
      this.validateAllStreamsB2A?.includes(false)
    ) {
      this.onDataEmit(ConfigFieldMapping.STREAMS_B2A, this.allStreamsConfigB2A, false);
    } else {
      this.onDataEmit(ConfigFieldMapping.STREAMS_B2A, this.allStreamsConfigB2A, true);
    }
    this.usedPortsB2A = [];
    this.usedStreamNumbersB2A = [];
    this.allStreamsConfigB2A.forEach(stream => {
      if (stream) {
        this.usedPortsB2A.push(Number(stream['udp-port']));
        this.usedStreamNumbersB2A.push(stream['stream-number']);
      }
    });
    this.availablePortsB2A = this.udpPortList.filter(port => !this.usedPortsB2A.includes(port));
    this.availableStreamNumbersB2A = this.streamNumbersB2A.filter(
      item => !this.usedStreamNumbersB2A.includes(item)
    );

    // Aggrigate both the tables
    this.totalIrA2B = 0;
    this.totalBwA2B = 0;
    this.totalIrB2A = 0;
    this.totalBwB2A = 0;
    this.allStreamsConfigA2B.forEach(item => {
      if (item && item[ConfigFieldMapping.STREAM_IN_USE]) {
        this.totalIrA2B += Number(item[ConfigFieldMapping.STREAM_L2_IR_A2B]);
        this.totalBwA2B += Number(item[ConfigFieldMapping.UDP_BW_A2B]);
      }
    });
    this.totalIrA2B = Number(this.totalIrA2B);
    this.totalIrA2B = this.totalIrA2B.toFixed(2);
    this.totalBwA2B = Number(this.totalBwA2B);
    this.totalBwA2B = this.totalBwA2B.toFixed(2);
    this.allStreamsConfigB2A.forEach(item => {
      if (item && item[ConfigFieldMapping.STREAM_IN_USE]) {
        this.totalIrB2A += Number(item[ConfigFieldMapping.STREAM_L2_IR_B2A]);
        this.totalBwB2A += Number(item[ConfigFieldMapping.UDP_BW_B2A]);
      }
    });
    this.totalIrB2A = Number(this.totalIrB2A);
    this.totalIrB2A = this.totalIrB2A.toFixed(2);
    this.totalBwB2A = Number(this.totalBwB2A);
    this.totalBwB2A = this.totalBwB2A.toFixed(2);
  }

  getMaxStreamTooltip(): string {
    let tooltipMsg = '';
    if (this.isValidCloneActionA2B && this.isValidCloneActionB2A) {
      tooltipMsg =
        'You have reached the maximum number of streams ' +
        this.streamRowsA2B[0].streamMaxServices +
        ' for a test.';
    }
    return tooltipMsg;
  }

  addStream(): void {
    if (this.direction !== 'unidirectional-b2a') {
      if (this.streamRowsA2B.length < this.streamRowsA2B[0].streamMaxServices) {
        if (this.streamRateConvention === 'l1-mbps') {
          if (this.vlan === 46) {
            this.initiateDefaultStreamA2B['streamUdpBwA2B'] = '8.76';
          } else if (this.vlan === 50) {
            this.initiateDefaultStreamA2B['streamUdpBwA2B'] = '8.68';
          } else if (this.vlan === 54) {
            this.initiateDefaultStreamA2B['streamUdpBwA2B'] = '8.61';
          }
        } else {
          if (this.vlan === 46) {
            this.initiateDefaultStreamA2B['streamUdpBwA2B'] = '9.10';
          } else if (this.vlan === 50) {
            this.initiateDefaultStreamA2B['streamUdpBwA2B'] = '9.02';
          } else if (this.vlan === 54) {
            this.initiateDefaultStreamA2B['streamUdpBwA2B'] = '8.95';
          }
        }
        this.createDataSource(this.initiateDefaultStreamA2B, 'tableA');
        this.validateStream('tableA');
        this.onDataChange();
      }
    }
    if (this.direction !== 'unidirectional-a2b') {
      if (this.streamRowsB2A.length < this.streamRowsB2A[0].streamMaxServices) {
        if (this.streamRateConvention === 'l1-mbps') {
          if (this.vlan === 46) {
            this.initiateDefaultStreamA2B['streamUdpBwB2A'] = '8.76';
          } else if (this.vlan === 50) {
            this.initiateDefaultStreamA2B['streamUdpBwB2A'] = '8.68';
          } else if (this.vlan === 54) {
            this.initiateDefaultStreamA2B['streamUdpBwB2A'] = '8.61';
          }
        } else {
          if (this.vlan === 46) {
            this.initiateDefaultStreamA2B['streamUdpBwB2A'] = '9.10';
          } else if (this.vlan === 50) {
            this.initiateDefaultStreamA2B['streamUdpBwB2A'] = '9.02';
          } else if (this.vlan === 54) {
            this.initiateDefaultStreamA2B['streamUdpBwB2A'] = '8.95';
          }
        }
        this.createDataSource(this.initiateDefaultStreamA2B, 'tableB');
        this.validateStream('tableB');
        this.onDataChange();
      }
    }
  }
  // eslint-disable-next-line
  createDataSource(rowData?: any, tableChange?: string): any {
    if (tableChange === 'tableA') {
      const stream = {
        isMultiSelectEnable: false,
        framesList: this.restoreFieldValues(ConfigFieldMapping.VALID_FRAME_SIZES),
        streamMaxServices: rowData
          ? rowData.streamMaxServices
          : this.config['valuesDefault']['maxServices'],
        streamNumber: this.getFreeStreamNumber(tableChange),
        streamName: 'service ' + this.getFreeStreamNumber(tableChange),
        streamType: rowData ? rowData.streamType : '',
        streamL2IrA2B: rowData ? rowData.streamL2IrA2B : '',
        streamL2IrB2A: rowData ? rowData.streamL2IrB2A : '',
        streamUdpBwA2B: rowData ? rowData.streamUdpBwA2B : '',
        streamUdpBwB2A: rowData ? rowData.streamUdpBwB2A : '',
        streamFrameSize: rowData ? rowData.streamFrameSize.toString() : '512',
        streamPacketLossRatio: rowData ? rowData.streamPacketLossRatio : '',
        streamJitterThreshold: rowData ? rowData.streamJitterThreshold : '',
        streamUdpPort: this.getFreeUdpPort(tableChange),
        streamCodec: rowData ? rowData?.streamCodec : '',
        streamSamplingRate: rowData ? rowData?.streamSamplingRate : '',
        streamCalls: rowData ? rowData?.streamCalls : '',
        streamVideoType: rowData ? rowData?.streamVideoType : '',
        streamCompression: rowData ? rowData?.streamCompression : '',
        streamChannels: rowData ? rowData?.streamChannels : '',
        isValidConfig: true,
        strmInUse: rowData ? rowData.strmInUse : true,
        streamAction: rowData ? rowData.streamAction : ''
      };
      this.usedPortsA2B.push(stream.streamUdpPort);
      this.usedStreamNumbersA2B.push(stream.streamNumber);
      this.streamRowsA2B.push(stream);
      this.defaultStreamsArrA2B[this.defaultStreamsArrA2B.length - 1]['stream-number'] =
        this.getFreeStreamNumber(tableChange) - 1;
      this.defaultStreamsArrA2B[this.defaultStreamsArrA2B.length - 1]['name'] =
        'service ' + (this.getFreeStreamNumber(tableChange) - 1);
      this.allStreamsConfigA2B.push(
        cloneDeep(this.defaultStreamsArrA2B[this.defaultStreamsArrA2B.length - 1])
      );
      this.dataSourceA2B.data = this.streamRowsA2B;
      this.availablePortsA2B = this.udpPortList.filter(item => !this.usedPortsA2B.includes(item));
      this.availableStreamNumbersA2B = this.streamNumbersA2B.filter(
        item => !this.usedStreamNumbersA2B.includes(item)
      );
      const index = this.dataSourceA2B?.data?.length - 1;
      this.onDataChange(stream.streamUdpPort, index, ConfigFieldMapping.UDP_PORT, tableChange);
      this.onDataChange(stream.streamFrameSize, index, ConfigFieldMapping.FRAME_SIZE, tableChange);
      this.onDataChange(stream.streamType, index, ConfigFieldMapping.STREAM_TYPE, tableChange);
      this.onDataChange(stream.streamNumber, index, ConfigFieldMapping.STREAM_NUMBER, tableChange);
      this.onDataChange(stream.streamName, index, ConfigFieldMapping.STREAM_NAME, tableChange);
      this.onDataChange(
        stream.streamL2IrA2B,
        index,
        ConfigFieldMapping.STREAM_L2_IR_A2B,
        tableChange
      );
      this.onDataChange(stream.streamUdpBwA2B, index, ConfigFieldMapping.UDP_BW_A2B, tableChange);
      this.onDataChange(
        stream.streamPacketLossRatio,
        index,
        ConfigFieldMapping.POCKET_LOSS_RATIO,
        tableChange
      );
      this.onDataChange(
        stream.streamJitterThreshold,
        index,
        ConfigFieldMapping.JITTER_THRESHOLD,
        tableChange
      );
      if (rowData.streamType === 'Voice') {
        this.onDataChange(stream.streamCodec, index, ConfigFieldMapping.CODEC, tableChange);
        this.onDataChange(
          stream.streamSamplingRate,
          index,
          ConfigFieldMapping.SAMPLING_RATE,
          tableChange
        );
        this.onDataChange(stream.streamCalls, index, ConfigFieldMapping.CALLS, tableChange);
      }
      if (rowData.streamType === 'Video') {
        this.onDataChange(
          stream.streamVideoType,
          index,
          ConfigFieldMapping.VIDEO_TYPE,
          tableChange
        );
        this.onDataChange(
          stream.streamCompression,
          index,
          ConfigFieldMapping.COMPRESSION,
          tableChange
        );
        this.onDataChange(stream.streamChannels, index, ConfigFieldMapping.CHANNELS, tableChange);
      }
    } else {
      const stream = {
        isMultiSelectEnable: false,
        framesList: this.restoreFieldValues(ConfigFieldMapping.VALID_FRAME_SIZES),
        streamMaxServices: rowData
          ? rowData.streamMaxServices
          : this.config['valuesDefault']['maxServices'],
        streamNumber: this.getFreeStreamNumber(tableChange),
        streamName:
          'service ' +
          (this.direction === 'unidirectional-b2a'
            ? this.getFreeStreamNumber(tableChange) - 10
            : this.getFreeStreamNumber(tableChange)),
        streamType: rowData ? rowData.streamType : '',
        streamL2IrA2B: rowData ? rowData.streamL2IrA2B : '',
        streamL2IrB2A: rowData ? rowData.streamL2IrB2A : '',
        streamUdpBwA2B: rowData ? rowData.streamUdpBwA2B : '',
        streamUdpBwB2A: rowData ? rowData.streamUdpBwB2A : '',
        streamFrameSize: rowData ? rowData.streamFrameSize.toString() : '512',
        streamPacketLossRatio: rowData ? rowData.streamPacketLossRatio : '',
        streamJitterThreshold: rowData ? rowData.streamJitterThreshold : '',
        streamUdpPort: this.getFreeUdpPort(tableChange),
        streamCodec: rowData ? rowData?.streamCodec : '',
        streamSamplingRate: rowData ? rowData?.streamSamplingRate : '',
        streamCalls: rowData ? rowData?.streamCalls : '',
        streamVideoType: rowData ? rowData?.streamVideoType : '',
        streamCompression: rowData ? rowData?.streamCompression : '',
        streamChannels: rowData ? rowData?.streamChannels : '',
        isValidConfig: true,
        strmInUse: rowData ? rowData.strmInUse : true,
        streamAction: rowData ? rowData.streamAction : ''
      };
      this.usedPortsB2A.push(stream.streamUdpPort);
      this.usedStreamNumbersB2A.push(stream.streamNumber);
      this.streamRowsB2A.push(stream);
      this.defaultStreamsArrB2A[this.defaultStreamsArrB2A.length - 1]['stream-number'] =
        this.getFreeStreamNumber(tableChange) - 1;
      this.defaultStreamsArrB2A[this.defaultStreamsArrB2A.length - 1]['name'] =
        'service ' + (this.getFreeStreamNumber(tableChange) - 1);
      this.allStreamsConfigB2A.push(
        cloneDeep(this.defaultStreamsArrB2A[this.defaultStreamsArrB2A.length - 1])
      );
      this.dataSourceB2A.data = this.streamRowsB2A;
      this.availablePortsB2A = this.udpPortList.filter(item => !this.usedPortsB2A.includes(item));
      this.availableStreamNumbersB2A = this.streamNumbersB2A.filter(
        item => !this.usedStreamNumbersB2A.includes(item)
      );
      const index = this.dataSourceB2A?.data?.length - 1;
      this.onDataChange(stream.streamUdpPort, index, ConfigFieldMapping.UDP_PORT, tableChange);
      this.onDataChange(stream.streamFrameSize, index, ConfigFieldMapping.FRAME_SIZE, tableChange);
      this.onDataChange(stream.streamType, index, ConfigFieldMapping.STREAM_TYPE, tableChange);
      this.onDataChange(stream.streamNumber, index, ConfigFieldMapping.STREAM_NUMBER, tableChange);
      this.onDataChange(stream.streamName, index, ConfigFieldMapping.STREAM_NAME, tableChange);
      this.onDataChange(
        stream.streamL2IrB2A,
        index,
        ConfigFieldMapping.STREAM_L2_IR_B2A,
        tableChange
      );
      this.onDataChange(stream.streamUdpBwB2A, index, ConfigFieldMapping.UDP_BW_B2A, tableChange);
      this.onDataChange(
        stream.streamPacketLossRatio,
        index,
        ConfigFieldMapping.POCKET_LOSS_RATIO,
        tableChange
      );
      this.onDataChange(
        stream.streamJitterThreshold,
        index,
        ConfigFieldMapping.JITTER_THRESHOLD,
        tableChange
      );
    }
  }

  getStreamName(): number {
    return this.streamRowsA2B?.[this.streamRowsA2B.length - 1]?.streamNumber + 1;
  }
  // eslint-disable-next-line
  onChangeStreamType(element: any, index: number, changeType: string): void {
    const dialogRef = this.dialog.open(UdpStreamTypeComponent, {
      data: {
        element: element,
        direction: this.direction,
        streamRateConvention: this.streamRateConvention,
        vlan: this.vlan,
        maxBandWidth: this.maxBandWidth,
        availablePorts: changeType === 'tableA' ? this.availablePortsA2B : this.availablePortsB2A,
        frameSizesObj: this.frameSizesObj,
        tableChange: changeType
      },
      disableClose: true
    });
    dialogRef.beforeClosed().subscribe(_res => {
      if (_res?.data) {
        element.streamType = _res?.data?.streamType;
        element.streamJitterThreshold = _res?.data?.jitterThreshold;
        element.streamPacketLossRatio = _res?.data?.packetLossRatio;
        element.streamUdpPort = _res?.data?.portNumber;
        this.updateUdpPortNumber(changeType, element);
        element.streamFrameSize = _res?.data?.streamFrameSize;
        if (changeType === 'tableA') {
          if (!this.usedPortsA2B.includes(element.streamUdpPort)) {
            this.usedPortsA2B.push(element.streamUdpPort);
          }
          element.streamL2IrA2B = _res?.data?.l2IrA2B;
          element.streamUdpBwA2B = _res?.data?.udpBwA2B;
          this.onDataChange(
            element.streamL2IrA2B,
            index,
            ConfigFieldMapping.STREAM_L2_IR_A2B,
            changeType
          );
          this.onDataChange(
            element.streamUdpBwA2B,
            index,
            ConfigFieldMapping.UDP_BW_A2B,
            changeType
          );
          // this.usedPortsA2B = [];
          // this.allStreamsConfigA2B.forEach(stream => this.usedPortsA2B.push(stream['udp-port']));
        } else {
          if (!this.usedPortsB2A.includes(element.streamUdpPort)) {
            this.usedPortsB2A.push(element.streamUdpPort);
          }
          element.streamL2IrB2A = _res?.data?.l2IrB2A;
          element.streamUdpBwB2A = _res?.data?.udpBwB2A;
          this.onDataChange(
            element.streamL2IrB2A,
            index,
            ConfigFieldMapping.STREAM_L2_IR_B2A,
            changeType
          );
          this.onDataChange(
            element.streamUdpBwB2A,
            index,
            ConfigFieldMapping.UDP_BW_B2A,
            changeType
          );
        }
        if (element.streamType === 'Video') {
          element.streamVideoType = _res?.data?.videoType;
          element.streamCompression = _res?.data?.compression;
          element.streamChannels = _res?.data?.channels;
          this.onDataChange(
            element.streamVideoType,
            index,
            ConfigFieldMapping.VIDEO_TYPE,
            changeType
          );
          this.onDataChange(
            element.streamCompression,
            index,
            ConfigFieldMapping.COMPRESSION,
            changeType
          );
          this.onDataChange(element.streamChannels, index, ConfigFieldMapping.CHANNELS, changeType);
        }
        if (element.streamType === 'Voice') {
          element.streamCodec = _res?.data?.codec;
          element.streamSamplingRate = _res?.data?.samplingRate;
          element.streamCalls = _res?.data?.calls;
          this.onDataChange(element.streamCodec, index, ConfigFieldMapping.CODEC, changeType);
          this.onDataChange(
            element.streamSamplingRate,
            index,
            ConfigFieldMapping.SAMPLING_RATE,
            changeType
          );
          this.onDataChange(element.streamCalls, index, ConfigFieldMapping.CALLS, changeType);
        }
        this.onDataChange(element.streamUdpPort, index, ConfigFieldMapping.UDP_PORT, changeType);
        this.onDataChange(
          element.streamFrameSize,
          index,
          ConfigFieldMapping.FRAME_SIZE,
          changeType
        );
        this.onDataChange(element.streamType, index, ConfigFieldMapping.STREAM_TYPE, changeType);
        this.onDataChange(
          element.streamNumber,
          index,
          ConfigFieldMapping.STREAM_NUMBER,
          changeType
        );
        this.onDataChange(
          element.streamPacketLossRatio,
          index,
          ConfigFieldMapping.POCKET_LOSS_RATIO,
          changeType
        );
        this.onDataChange(
          element.streamJitterThreshold,
          index,
          ConfigFieldMapping.JITTER_THRESHOLD,
          changeType
        );
      }
    });
  }
  // eslint-disable-next-line
  updateUdpPortNumber(tableChange: string, element: any): void {
    if (tableChange === 'tableA') {
      const updateStreamNumber = element['streamNumber'] + 10;
      const index = this.streamRowsB2A.findIndex(
        item => item['streamNumber'] === updateStreamNumber
      );
      const portIndex = this.streamRowsB2A.findIndex(
        item => item['streamUdpPort'] === element.streamUdpPort
      );
      if (portIndex >= 0 && index >= 0 && portIndex !== index) {
        this.streamRowsB2A[portIndex]['streamUdpPort'] = this.streamRowsB2A[index]['streamUdpPort'];
      }
      if (index >= 0) {
        this.streamRowsB2A[index]['streamUdpPort'] = element['streamUdpPort'];
        this.allStreamsConfigB2A[index]['udp-port'] = element['streamUdpPort'];
      }
    } else {
      const updateStreamNumber = element['streamNumber'] - 10;
      const index = this.streamRowsA2B.findIndex(
        item => item['streamNumber'] === updateStreamNumber
      );
      const portIndex = this.streamRowsA2B.findIndex(
        item => item['streamUdpPort'] === element.streamUdpPort
      );
      if (portIndex >= 0 && index >= 0 && portIndex !== index) {
        this.streamRowsA2B[portIndex]['streamUdpPort'] = this.streamRowsA2B[index]['streamUdpPort'];
      }
      if (index >= 0) {
        this.streamRowsA2B[index]['streamUdpPort'] = element['streamUdpPort'];
        this.allStreamsConfigA2B[index]['udp-port'] = element['streamUdpPort'];
      }
    }
  }
  // eslint-disable-next-line
  checkValidation(field: string, value: any, element?: any, tableChange?: string): any {
    const errMsg = { isValid: false, message: '' };
    if (field === 'name' && isEmpty(value)) {
      errMsg.isValid = true;
      errMsg.message = 'Name is required';
      this.errorValidationObj.isValidName = false;
    } else if (field === 'name' && this.validateName(value)) {
      errMsg.isValid = true;
      errMsg.message =
        'The value ' + value + ' has already been used. Please choose a unique value.';
      this.errorValidationObj.isValidName = false;
    } else if (field === 'name') {
      this.errorValidationObj.isValidName = true;
    }
    if (element) {
      if (this.errorValidationObj.isValidName) {
        element.isValidConfig = true;
      } else {
        element.isValidConfig = false;
      }
    }
    if (field === 'actionDisable') {
      if (tableChange === 'tableA') {
        const enableStreams = this.allStreamsConfigA2B.filter(
          item => item[ConfigFieldMapping.STREAM_IN_USE]
        );
        if (enableStreams?.length <= 1) {
          this.errorValidationObj.isValidDisableStream = false;
        } else {
          this.errorValidationObj.isValidDisableStream = true;
        }
      } else {
        const enableStreams = this.allStreamsConfigB2A.filter(
          item => item[ConfigFieldMapping.STREAM_IN_USE]
        );
        if (enableStreams?.length <= 1) {
          this.errorValidationObj.isValidDisableStream = false;
        } else {
          this.errorValidationObj.isValidDisableStream = true;
        }
      }
    }
    if (tableChange === 'tableA') {
      this.onDataChange();
    } else {
      this.onDataChange();
    }

    return errMsg;
  }

  validateName(value: string): boolean {
    const streamNamesA2B = this.streamRowsA2B
      .map(item => item['streamName'])
      .filter(item => item === value);
    const streamNamesB2A = this.streamRowsB2A
      .map(item => item['streamName'])
      .filter(item => item === value);
    if (
      streamNamesA2B?.length > 1 ||
      streamNamesB2A?.length > 1 ||
      (streamNamesA2B.includes(value) &&
        streamNamesB2A.includes(value) &&
        this.direction !== 'unidirectional-b2a')
    ) {
      return true;
    } else {
      return false;
    }
  }

  getFreeUdpPort(tableChange: string): any {
    if (tableChange === 'tableA') {
      this.availablePortsA2B = this.udpPortList.filter(item => !this.usedPortsA2B.includes(item));
      return this.availablePortsA2B[0];
    } else {
      this.availablePortsB2A = this.udpPortList.filter(item => !this.usedPortsB2A.includes(item));
      return this.availablePortsB2A[0];
    }
  }

  getFreeStreamNumber(tableChange: string): any {
    if (tableChange === 'tableA') {
      this.availableStreamNumbersA2B = this.streamNumbersA2B.filter(
        item => !this.usedStreamNumbersA2B.includes(item)
      );
      return this.availableStreamNumbersA2B[0];
    } else {
      this.availableStreamNumbersB2A = this.streamNumbersB2A.filter(
        item => !this.usedStreamNumbersB2A.includes(item)
      );
      return this.availableStreamNumbersB2A[0];
    }
  }
  // eslint-disable-next-line
  onDataEmit(key: string, newValue: any, isValid: boolean): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: key,
      newValue: newValue,
      isValid: isValid
    });
  }
  // eslint-disable-next-line
  copyA2bData(element, index: number): void {
    const tableChange = 'tableB';
    const findIndex = this.streamRowsB2A.findIndex(
      item => item['streamNumber'] === element.streamNumber + 10
    );
    const portIndex = this.streamRowsB2A.findIndex(
      item => item['streamUdpPort'] === element.streamUdpPort
    );
    if (portIndex >= 0 && portIndex !== index) {
      this.streamRowsB2A[portIndex]['streamUdpPort'] =
        this.streamRowsB2A[findIndex]['streamUdpPort'];
    }
    if (findIndex >= 0) {
      (this.streamRowsB2A[findIndex]['streamMaxServices'] = element.streamMaxServices),
        (this.streamRowsB2A[findIndex]['streamType'] = element.streamType);
      this.streamRowsB2A[findIndex]['streamL2IrB2A'] = element.streamL2IrA2B;
      this.streamRowsB2A[findIndex]['streamUdpBwB2A'] = element.streamUdpBwA2B;
      this.streamRowsB2A[findIndex]['streamFrameSize'] = element.streamFrameSize;
      this.streamRowsB2A[findIndex]['streamPacketLossRatio'] = element.streamPacketLossRatio;
      this.streamRowsB2A[findIndex]['streamJitterThreshold'] = element.streamJitterThreshold;
      this.streamRowsB2A[findIndex]['streamUdpPort'] = element.streamUdpPort;
      this.streamRowsB2A[findIndex]['streamCodec'] = element.streamCodec;
      this.streamRowsB2A[findIndex]['streamSamplingRate'] = element.streamSamplingRate;
      this.streamRowsB2A[findIndex]['streamCalls'] = element.streamCalls;
      this.streamRowsB2A[findIndex]['streamVideoType'] = element.streamVideoType;
      this.streamRowsB2A[findIndex]['streamCompression'] = element.streamCompression;
      this.streamRowsB2A[findIndex]['streamChannels'] = element.streamChannels;
      this.dataSourceB2A.data = this.streamRowsB2A;
    } else {
      const stream = {
        isMultiSelectEnable: false,
        framesList: this.restoreFieldValues(ConfigFieldMapping.VALID_FRAME_SIZES),
        streamMaxServices: element
          ? element.streamMaxServices
          : this.config['valuesDefault']['maxServices'],
        streamNumber: this.getFreeStreamNumber(tableChange),
        streamName: 'service ' + this.getFreeStreamNumber(tableChange),
        streamType: element.streamType,
        streamL2IrB2A: element.streamL2IrA2B,
        streamUdpBwB2A: element.streamUdpBwA2B,
        streamCodec: element.streamCodec,
        streamSamplingRate: element.streamSamplingRate,
        streamCalls: element.streamCalls,
        streamVideoType: element.streamVideoType,
        streamCompression: element.streamCompression,
        streamChannels: element.streamChannels,
        streamFrameSize: element.streamFrameSize.toString(),
        streamPacketLossRatio: element.streamPacketLossRatio,
        streamJitterThreshold: element.streamJitterThreshold,
        streamUdpPort: element.streamUdpPort,
        isValidConfig: true,
        streamAction: element.streamAction
      };
      this.createDataSource(stream, tableChange);
    }
    this.validateStream(tableChange);
    this.onDataChange();
  }
  // eslint-disable-next-line
  updateStreamData(stream: any, vlan: number, convention: string, tableChange: string): any {
    const streamData = stream;
    if (streamData) {
      if (tableChange === 'tableA') {
        const frameSize = parseInt(this.setupService.removeCustom(stream['frame-size']));
        if (streamData['stream-type'] === 'Data') {
          if (streamData['l2-ir-a2b']) {
            streamData['udp-bw-a2b'] = this.setupService.updateBandwidthValue(
              streamData['l2-ir-a2b'],
              vlan,
              frameSize,
              convention
            );
          }
        } else if (streamData['stream-type'] === 'Voice') {
          if (streamData['udp-bw-a2b']) {
            streamData['l2-ir-a2b'] = this.setupService.updateIrValue(
              streamData['udp-bw-a2b'],
              vlan,
              frameSize,
              convention
            );
          }
        } else {
          if (streamData['udp-bw-a2b']) {
            streamData['l2-ir-a2b'] = this.setupService.updateIrValue(
              streamData['udp-bw-a2b'],
              vlan,
              frameSize,
              convention
            );
          }
          if (streamData['l2-ir-a2b']) {
            streamData['udp-bw-a2b'] = this.setupService.updateBandwidthValue(
              streamData['l2-ir-a2b'],
              vlan,
              frameSize,
              convention
            );
          }
        }
      } else {
        const frameSize = parseInt(this.setupService.removeCustom(stream['frame-size']));
        if (streamData['stream-type'] === 'Data') {
          if (streamData['l2-ir-b2a']) {
            streamData['udp-bw-b2a'] = this.setupService.updateBandwidthValue(
              streamData['l2-ir-b2a'],
              vlan,
              frameSize,
              convention
            );
          }
        } else if (streamData['stream-type'] === 'Voice') {
          if (streamData['udp-bw-b2a']) {
            streamData['l2-ir-b2a'] = this.setupService.updateIrValue(
              streamData['udp-bw-b2a'],
              vlan,
              frameSize,
              convention
            );
          }
        } else {
          if (streamData['udp-bw-b2a']) {
            streamData['l2-ir-b2a'] = this.setupService.updateIrValue(
              streamData['udp-bw-b2a'],
              vlan,
              frameSize,
              convention
            );
          }
          if (streamData['l2-ir-b2a']) {
            streamData['udp-bw-b2a'] = this.setupService.updateBandwidthValue(
              streamData['l2-ir-b2a'],
              vlan,
              frameSize,
              convention
            );
          }
        }
      }
    }
    return streamData;
  }

  ngOnDestroy(): void {
    this.unsubscribe.complete();
    this.unsubscribe.next();
    if (this.tabsubscription) {
      this.tabsubscription.unsubscribe();
    }
  }

  // eslint-disable-next-line
  enableOrDisableStream(element: any, index: number, tableChange: string): void {
    if (element) {
      element.strmInUse = !element.strmInUse;
      this.onDataChange(element.strmInUse, index, ConfigFieldMapping.STREAM_IN_USE, tableChange);
    }
  }

  // eslint-disable-next-line
  checkRemoveActionValid(element: any, tableChange: string): void {
    if (tableChange === 'tableA') {
      const enableStreams = this.allStreamsConfigA2B.filter(
        item => item[ConfigFieldMapping.STREAM_IN_USE]
      );
      if (enableStreams?.length === 1 && element.strmInUse) {
        this.isValidRemove = true;
      } else {
        this.isValidRemove = false;
      }
    } else {
      const enableStreams = this.allStreamsConfigB2A.filter(
        item => item[ConfigFieldMapping.STREAM_IN_USE]
      );
      if (enableStreams?.length === 1 && element.strmInUse) {
        this.isValidRemove = true;
      } else {
        this.isValidRemove = false;
      }
    }
  }
}
